import React from 'react';


const InputTextArea = ({label, value,placeholder, name, onChange ,required  }) => {
    return (
        <div className="InputTextArea wrap-adminInput">
            <label className="input-label" htmlFor={name}>{label}</label>
            <textarea className="input-el" value = {value} onChange = {onChange} placeholder={placeholder} name={name} id={`codex-editor`} cols="30" rows="10" required = {required}></textarea>
        </div>
    );
}

export default InputTextArea;